import React from 'react';
import ItemFooterAction from './components/ItemFooterAction';
import './styles.css';

const ItemFooterActions = props => {
  const { actions, item } = props;
  return (
    <div className="item-footer-actions">
      {actions.map((action, index) =>
        action.hidden ? null : (
          <ItemFooterAction
            disabled={action.disabled}
            actions={action}
            item={item}
            key={index}
          />
        )
      )}
    </div>
  );
};

export default ItemFooterActions;
